/* global __, Modal, Toasts */
$(function () {
  'use strict'

  var FILE_TYPES = /(^image\/|\.)(gif|jpe?g|png)$/i
  var FILE_MAX_SIZE = 10000000 // 10MB
  var MESSAGES = {
    thumbnail: __('Не удалось прочитать изображение. Проверьте тип изображения'),
    missingFileName: __('Не указано имя файла'),
    acceptFileTypes: __('Неверный тип файла. Поддерживаемые типы файлов: jpg, gif, png'),
    maxFileSize: __('Превышен максимальный размер файла'),
    '1': __('Превышен максимальный размер файла'),
    unknown: __('Ошибка при загрузке файла'),
    minResolution: __('Изображение слишком маленькое'),
    maxResolution: __('Изображение слишком большое'),
    'Request Entity Too Large': __('Изображение слишком большое'),
    maxNumberOfFiles: __('Слишком много файлов')
  }

  var TEXT = {
    ideabookName: __('Название коллекции'),
    loading: __('Дождитесь окончания загрузки…'),
    addPhotoFirst: __('Сперва добавьте фотографии…'),
    uploadMore: __('Загрузить еще…'),
    insertToMessage: __('Вставить в сообщение!'),
    addToIdeabook: __('Добавить в коллекцию'),
    addMarketplaceItems: __('Сохранить'),
    addToPortfolio: __('Сохранить'),
    pinToACard: __('Вставить в карточку!'),
    inUploadQueue: __('В очереди на загрузку'),
    description: __('Описание'),
    enterDescription: __('Опишите фотографию здесь'),
    wrongImageType: __('Неверный тип файла (%s). Поддерживаемые типы файлов: jpg, gif, png'),
    notUpload: __('Файл «%s» не загружен.'),
    uploadPercents: __('Загружено: {percents}%'),
    titleUploadPhotos: __('{percents}% загрузка фотографий — {documentTitle}')
  }

  var jcropApi
  var $profileImageTrigger = $()
  var $clickedProfileImageTrigger = $()
  var modalId = 'modal_avatar-loader-crop'
  var $modal = $()
  if (document.innerWidth > 767) {
    var $cropWindow = $()
  }
  var $modalImage = $()
  var $preview = $()
  var $previewWrapper = $()
  var imageWidth = 0
  var imageHeight = 0
  var $uploadedImg = null
  var $loader
  var jqXHR
  var $error
  var $title
  var $imageBlock
  var $saveButton = $()

  var showPreview = function (coords) {
    var rx = $previewWrapper.width() / coords.w
    var ry = $previewWrapper.height() / coords.h
    $preview.css({
      width: Math.round(rx * imageWidth) + 'px',
      height: Math.round(ry * imageHeight) + 'px',
      marginLeft: '-' + Math.round(rx * coords.x) + 'px',
      marginTop: '-' + Math.round(ry * coords.y) + 'px'
    }).show()
  }

  var release = function () {
    jcropApi.setSelect([0, 0, 100, 100])
  }

  var showError = function (message, changeTitle) {
    if (changeTitle) {
      $title.html('К сожалению, произошла ошибка')
    }
    $loader.removeClass('modal_image-crop__loader-active')
    $saveButton.hide()
    $previewWrapper.hide()
    $error.html(message).show()
    Toasts.pushToast(message, 'fail')
  }

  var addFile = function (data, aspectRatio) {
    var file = data.files[0]
    var error = null

    // validate
    if (!(FILE_TYPES.test(file.type) || FILE_TYPES.test(file.name))) {
      error = 'acceptFileTypes'
    }
    else if (FILE_MAX_SIZE && FILE_MAX_SIZE < file.size) {
      error = 'maxFileSize'
    }
    if (error) {
      var message = MESSAGES[error] || MESSAGES.unknown
      if (file.name) {
        message = TEXT.notUpload.replace('%s', file.name) + ' ' + message
      }
      return showError(message)
    }

    data.progressCallback = $.Callbacks()

    // send
    jqXHR = data.submit()

    jqXHR.success(function (result) {
      var file = result
      if (file.error) {
        var message = file.error
        return showError(message)
      }
      else {
        if (document.innerWidth > 767) {
          $cropWindow.css({'max-width': ''})
        }

        $error.hide()
        $saveButton.show()
        $previewWrapper.show()
        $imageBlock.removeClass('modal_image-crop__image-hidden')

        $uploadedImg = $('<img src="' + file.url + '" style="position: absolute; max-width: none; max-height: none; width: auto; height: auto;" />')
        $modalImage.append($uploadedImg)
        $preview.attr('src', $uploadedImg.attr('src'))
        $uploadedImg.on('load', function () {
          imageWidth = $uploadedImg.width()
          imageHeight = $uploadedImg.height()

          var minWidth = 100
          var minHeight = 100

          if (imageWidth < minWidth || imageHeight < minHeight) {
            $uploadedImg.remove()
            $imageBlock.addClass('modal_image-crop__image-hidden')
            showError('Выбрано слишком маленькое изображение.' + (minWidth ? ' Минимальная ширина - ' + minWidth + '.' : '') + (minHeight ? ' Минимальная высота - ' + minHeight + '.' : ''))
            return
          }

          var selectWidth = parseInt(imageWidth / 1.5, 10)
          var selectHeight = parseInt(imageHeight / 1.5, 10)

          selectWidth = parseInt(Math.min(selectWidth, selectHeight * aspectRatio), 10)
          selectWidth = parseInt(Math.max(selectWidth, minWidth), 10)
          selectHeight = parseInt(selectWidth / aspectRatio, 10)

          var selectLeft = parseInt(Math.max(0, (imageWidth - selectWidth) / 2), 10)
          var selectTop = parseInt(Math.max(0, (imageHeight - selectHeight) / 2), 10)

          var boxWidth = window.innerWidth > 767 ? 430 : window.innerWidth
          var boxHeight = window.innerWidth > 767 ? 300 : 'auto'

          if (imageWidth < imageHeight && window.innerWidth < 768) {
            boxHeight = window.innerHeight * 0.6
          }

          $uploadedImg.Jcrop(
            {
              aspectRatio: aspectRatio,
              bgColor: 'black',
              bgOpacity: 0.4,
              minSize: [minWidth, minHeight],
              setSelect: [selectLeft, selectTop, selectLeft + selectWidth, selectTop + selectHeight],
              boxHeight: boxHeight,
              boxWidth: boxWidth,
              onChange: showPreview,
              onSelect: showPreview,
              onRelease: release,
              keySupport: false
            },
            function () {
              jcropApi = this
              var imageHolderWidth = $modalImage.width()
              var imagePreviewHolderWidth = $previewWrapper.width()
              if (document.innerWidth > 767) {
                var newWindowWidth = parseInt($cropWindow.css('max-width'), 10) - (430 - imageHolderWidth) - (210 - imagePreviewHolderWidth) + 36
                $cropWindow.css({'max-width': newWindowWidth + 'px'})
              }
              $loader.removeClass('modal_image-crop__loader-active')
            }
          )
        })
      }
    })
    jqXHR.error(function (jqXHR, textStatus, errorThrown) {
      if (errorThrown === 'abort') {
        // console.debug('File Upload has been canceled');
      }
      else {
        var message
        if (jqXHR.status === 400) {
          message = jqXHR.responseJSON.error
        }
        else {
          message = 'Произошла ошибка загрузки изображения, попробуйте загрузить повторно.'
        }
        showError(message, true)
      }
    })
  }

  $profileImageTrigger = $('[data-profile-image-trigger]')

  if (!$profileImageTrigger.length) {
    return
  }

  $modal = $('#' + modalId)
  if (document.innerWidth > 767) {
    $cropWindow = $modal.find('.modall__window')
  }
  $imageBlock = $modal.find('.modal_image-crop__image')
  $modalImage = $modal.find('.modal_image-crop__image__image')
  $preview = $modal.find('.modal_image-crop__image-preview__src')
  $previewWrapper = $preview.closest('.modal_image-crop__image-preview')
  $loader = $modal.find('.modal_image-crop__loader')
  $error = $modal.find('.modal_image-crop__error')
  $title = $modal.find('.modal_image-crop__title')
  $saveButton = $modal.find('.modal_image-crop__image-submit')

  $profileImageTrigger.on('click', function () {
    $clickedProfileImageTrigger = $(this)
    var $profileImageInput = $clickedProfileImageTrigger.closest('[data-profile-image-wrapper]').find('[data-profile-image-input]')

    $profileImageInput.fileupload({
      dataType: 'json',
      url: $clickedProfileImageTrigger.data('ajaxUrl'),
      formData: {
        from: location.protocol + '//' + location.host,
        useRedirect: ($.support.xhrFormDataFileUpload || $.support.xhrFileUpload) ? '' : 'yes'
      },
      sequentialUploads: true,
      process: [
        {
          action: 'load',
          fileTypes: FILE_TYPES,
          maxFileSize: FILE_MAX_SIZE
        },
        {
          action: 'save'
        }
      ],
      dropZone: $clickedProfileImageTrigger,
      add: function (e, data) {
        $(this).fileupload('process', data).done(function () {
          addFile(data, $clickedProfileImageTrigger.data('aspect-ratio'))
        })
      },
      start: function () {
        $title.html($clickedProfileImageTrigger.data('popupTitle'))
        window.Modal.openModal(modalId)
        $loader.addClass('modal_image-crop__loader-active')

        if ($clickedProfileImageTrigger.data('uploadCover')) {
          $('.modal_image-crop__image__right').addClass('layout__none')
        }
      },
      stop: function () {
        $loader.removeClass('modal_image-crop__loader-active')
      }
    })
    .bind('fileuploaddrop', function (event, data) {
      console.log(event, data)
      event.stopPropagation()
    })

    $profileImageInput.fileupload('enable')
  })

  $saveButton.on('click', function (e) {
    e.preventDefault()

    $loader.addClass('modal_image-crop__loader-active')

    var selection = jcropApi.tellSelect()

    var naturalWidth = $uploadedImg.get(0).naturalWidth
    var naturalHeight = $uploadedImg.get(0).naturalHeight
    var diff = 0

    var crop_x = parseInt(selection.x, 10)
    var crop_width = parseInt(selection.w, 10)
    var crop_right_point = crop_x + crop_width
    if (crop_right_point > naturalWidth) {
      diff = crop_right_point - naturalWidth
      crop_width = crop_width - diff - 1
    }

    var crop_y = parseInt(selection.y, 10)
    var crop_height = parseInt(selection.h, 10)
    var crop_bottom_point = crop_y + crop_height
    if (crop_bottom_point > naturalHeight) {
      diff = crop_bottom_point - naturalHeight
      crop_height = crop_height - diff - 1
    }

    var crop_image

    $.ajax({
      data: {
        url: $uploadedImg.attr('src'),
        crop: {
          width: crop_width,
          height: crop_height,
          x: crop_x,
          y: crop_y
        }
      },
      cache: false,
      url: $clickedProfileImageTrigger.data('ajaxCropUrl'),
      type: 'POST'
    })
    .done(function (data) {
      crop_image = data.url
      $clickedProfileImageTrigger.closest('[data-profile-image-wrapper]').find('[data-profile-image]').css('backgroundImage', 'url("' + data.thumb_url + '")')
      $clickedProfileImageTrigger.closest('[data-profile-image-wrapper]').find('.avatar-placeholder__initials').css('display', 'none')
      $.ajax({
        data: {
          src_image_url: crop_image
        },
        cache: false,
        url: $clickedProfileImageTrigger.data('saveUrl'),
        type: 'POST'
      })
      .done(function () {
        Modal.closeModal(modalId)
      })
      .fail(function (xhr) {
        var message = ''
        if (typeof (xhr.responseJSON) !== 'undefined' && typeof (xhr.responseJSON.error) !== 'undefined') {
          message = xhr.responseJSON.error
        }
        else {
          message = 'Произошла ошибка сохранения изображения. Попробуйте повторить попытку.'
        }

        showError(message)
      })
    })
    .fail(function (xhr) {
      var message = ''
      if (typeof (xhr.responseJSON) !== 'undefined' && typeof (xhr.responseJSON.error) !== 'undefined') {
        message = xhr.responseJSON.error
      }
      else {
        message = 'Произошла ошибка сохранения изображения. Попробуйте повторить попытку.'
      }

      showError(message)
    })
  })

  $(document).on('Modal::close', function (event, modal) {
    if (modal.prop('id') !== modalId) {
      return
    }

    if (jqXHR) {
      jqXHR.abort()
    }
    if (jcropApi) {
      jcropApi.destroy()
    }
    $uploadedImg = null
    $imageBlock.addClass('modal_image-crop__image-hidden')
    $error.hide()
    $loader.removeClass('modal_image-crop__loader-active')
    $modalImage.empty()
  })
})
